import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FilterSetting, LayerTypeFilter} from '../../../configuration/model/LayerTypeFilter';
import { NgStyle } from '@angular/common';
import { ColorPickerDirective } from 'ngx-color-picker';
import { LineTypeSelectorComponent } from '../line-type-selector/line-type-selector.component';

@Component({
  selector: 'app-map-theme-editor',
  templateUrl: './map-theme-editor.component.html',
  styleUrls: ['./map-theme-editor.component.scss'],
  imports: [NgStyle, ColorPickerDirective, LineTypeSelectorComponent],
})
export class MapThemeEditorComponent {
  @Input() layerType?: LayerTypeFilter;
  @Output() colorsChangedEvent: EventEmitter<LayerTypeFilter> = new EventEmitter();

  showDetailIndex: number = null;

  protected readonly Math = Math;

  editLineStyle(index: number, lineStyle: FilterSetting) {
    if (this.showDetailIndex === null || index !== this.showDetailIndex) {
      this.showDetailIndex = index;
    } else {
      this.showDetailIndex = null;
    }
  }

  onLineStyleChange() {
    this.colorsChangedEvent.emit(this.layerType);
  }
}
